import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons'

import { Button } from '@domain-group/suit-theme'

import type { UseArtworkPayload } from '@hooks/useArtwork'
import type { UseOrderItemPayload } from '@hooks/useOrderItem'

interface ReviewStatusProps {
  artworkPayload: UseArtworkPayload,
  callbacks: {
    manageOrderItem: UseOrderItemPayload['callbacks']['manageOrderItem'],
  },
}

const ReviewStatus = (props: ReviewStatusProps) => {
  const {
    artworkPayload: {
      allArtworkReviewsApproved,
      filteredArtworkReviews,
      hasFilteredArtworkReviews,
    },
    callbacks: {
      manageOrderItem,
    },
  } = props

  const reviewCount = filteredArtworkReviews.length

  // No Reviews
  if (!hasFilteredArtworkReviews){
    return null
  }

  return (
    <Button
      buttonStyle={allArtworkReviewsApproved ? 'secondaryCreate' : 'secondaryDestroy'}
      icon={<FontAwesomeIcon icon={allArtworkReviewsApproved ? faCheckCircle : faTimesCircle} />}
      // @ts-expect-error
      marginBottom={['small', 0]}
      onClick={manageOrderItem}
      size="medium"
      width={['100%', 200]}
    >
      {`Reviewed by ${reviewCount} ${reviewCount === 1 ? 'User' : 'Users'}`}
    </Button>
  )
}

export default ReviewStatus
